import "./userOrderTable.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";

const UserOrderTableList = ({ data,userID }) => {
  const navigate = useNavigate();
  const handleClick = (id) => {
    const eUrl = `/orders/${id}`;
    navigate(eUrl, { state: { userID } });
  };
  return (
    <TableContainer component={Paper} className="userOrderTable">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className="tableCell">Book/Note ID</TableCell>
            <TableCell className="tableCell">Name</TableCell>
            <TableCell className="tableCell">Type</TableCell>
            <TableCell className="tableCell">Publisher</TableCell>
            <TableCell className="tableCell">PDF Url</TableCell>
            <TableCell className="tableCell">PDF Passwords</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.map((element) => (
              <TableRow key={element.id}>
                <TableCell className="tableCell">
                  <div className="bookID" >
                    <a
                      onClick={() => handleClick(element.id)}
                      style={{ textDecoration: "none" }}
                    >
                      {element.id}
                    </a>
                  </div>
                </TableCell>
                <TableCell className="tableCell">
                  <div className="userOrderTablecellWrapper">
                    <img
                      src={element.thumbImage}
                      alt=""
                      className="userOrderTableimage"
                    />
                    {element.name}
                  </div>
                </TableCell>
                <TableCell className="tableCell">{element.eType}</TableCell>
                <TableCell className="tableCell">{element.publisher}</TableCell>
              
                <TableCell className="tableCell">
                  <div className="userOrderTablecellWrapper">
                    <img
                      src="https://th.bing.com/th/id/OIP.zk2laqbASpdFh90T27XngAHaF2?w=247&h=195&c=7&r=0&o=5&dpr=1.5&pid=1.7"
                      className="userOrderTablePDF"
                    />
                    <a
                      href={element.pdfUrl}
                      target="_blank"
                      style={{ textDecoration: "none" }}
                    >
                      View PDF
                    </a>
                  </div>
                </TableCell>
                <TableCell className="tableCell">
                  {element.pdf_password}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserOrderTableList;
